import { motion } from "framer-motion";
import { HeartHandshake, MonitorSmartphone, TrendingUp } from "lucide-react";

const ITEMS = [
    { icon: HeartHandshake, title: "Learner-centred lessons", text: "Planned around learning needs" },
    { icon: MonitorSmartphone, title: "Online convenience", text: "Learn from home" },
    { icon: TrendingUp, title: "Confidence through practice", text: "Build skills step by step" },
];

export const TrustStrip = () => (
    <section className="border-y border-ground-line/60 bg-ground" data-testid="trust-strip">
        <div className="mx-auto grid max-w-7xl gap-8 px-6 py-10 sm:grid-cols-3">
            {ITEMS.map((item, i) => (
                <motion.div
                    key={item.title}
                    className="flex items-start gap-4"
                    initial={{ opacity: 0, y: 16 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5, delay: i * 0.12 }}
                >
                    <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-sun/15 text-sun">
                        <item.icon className="h-5 w-5" />
                    </span>
                    <div>
                        <p className="font-heading font-bold text-ink">{item.title}</p>
                        <p className="text-sm text-mist">{item.text}</p>
                    </div>
                </motion.div>
            ))}
        </div>
    </section>
);
